import AccessDeniedHandler from '@/components/access-denied/AccessDeniedHandler'
import { RouteObject } from 'react-router-dom'

const AccessDeniedRoute: RouteObject = {
  path: '/access-denied',
  element: <AccessDeniedHandler />,
}

export default AccessDeniedRoute
